<template>
  <div class="go-dashboard">
    <div class="top-logo">
      <img :src="logo" width="160" alt @click="turnToHome" style="cursor: pointer"/>
    </div>
    <iframe id="myframe" :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logo: require('@/assets/images/logo.svg'),
      iframeSrc: ''
    }
  },
  methods: {
    turnToHome() {
      this.$router.push({
        path: '/'
      })
    },
  },
  created() {
    this.iframeSrc = `${location.protocol}//go.cyberklick.com.cn/dashboard#/panel/index?isCA=true`
    window.addEventListener('message', function(event) {
      if(event.data === 'logout') {
        this.$store.dispatch('user/logout')
      }
      if(event.data.type === 'preview') {
        window.open(`${location.origin}/goDashboardPreview/${event.data.id}`, '_blank')
      }
    }, false)
  }
}
</script>
<style lang="less" scoped>
.go-dashboard{
  height: 100%;
  .top-logo {
    padding-left:16px;
    background: rgb(241, 243, 248);
    height: 56px;
    display: flex;
    align-items: center;
  }
  iframe{
    width: 100%;
    height: calc(100vh - 61px);
  }
}
</style>